export default "__VITE_ASSET__B9wr2jNK__"